export default __webpack_public_path__ + "static/media/prohibition.2121496b.png";